import { render } from "./text-bars.vue?vue&type=template&id=09a8a5da&scoped=true"
const script = {}

import "./text-bars.vue?vue&type=style&index=0&id=09a8a5da&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/test-event-admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-09a8a5da"],['__file',"src/views/other/cssfx/components/text-bars.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "09a8a5da"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('09a8a5da', __exports__)) {
    console.log('reload')
    api.reload('09a8a5da', __exports__)
  }
  
  module.hot.accept("./text-bars.vue?vue&type=template&id=09a8a5da&scoped=true", () => {
    console.log('re-render')
    api.rerender('09a8a5da', render)
  })

}


export default __exports__